export const statusMap = {
    "blocked" : {
        value: 'Blocked'
    },
    "hold": {
        value: 'Pending at City Finance'
    },
    "pending" : {
        value: 'Pending at L1 Approver'
    },
    "approved_by_city_head": {
        value: 'Pending at L2 Approver'
    },
    "rejected_by_city_head" : {
        value: 'Rejected By L1 Approver'
    },
    "rejected_by_city_finance": {
        value: 'Rejected By City Finance'
    },
    "rejected_by_central_finance": {
        value: 'Rejected by L2 Approver'
    },
    "approved_by_central_finance": {
        value: 'BUF Ready'
    },
    "deleted": {
        value: 'Payment Deleted'
    },
    "payment_init": {
        value: 'BUF Generated'
    },
    "hold_at_processed": {
        value: 'Hold at Processed Payment'
    }
}

export const billSubReportStatusMap = {
    "blocked" : {
        value: 'Payment Blocked'
    },
    "hold": {
        value: 'Pending at City Finance'
    },
    "pending" : {
        value: 'Pending at L1 Approver'
    },
    "deleted" : {
        value: 'Payment Deleted'
    },
    "approved_by_city_head": {
        value: 'Pending at L2 Approver'
    },
    "rejected_by_city_finance": {
        value: 'Rejected By City Finance'
    },
    "rejected_by_city_head" : {
        value: 'Rejected By L1 Approver'
    },
    "rejected_by_central_finance": {
        value: 'Rejected by L2 Approver'
    },
    "approved_by_central_finance": {
        value: 'BUF Ready'
    },
    "payment_init": {
        value: 'BUF Generated'
    },
    "hold_at_processed": {
        value: 'Hold at Processed Payment'
    }
}

export const accountingReportStatusMap = {
    "accounted": {
        value: 'Accounted'
    }
}

export const businessUnitMap = {
    "coliving": {
        value: 'Co-Living'
    },
    "co-living": {
        value: 'Co-Living'
    },
    "zvacations": {
        value: 'Z Vacations'
    },
    "hotel-Z": {
        value: 'Hotel Z'
    },
    "industrial-housing": {
        value: 'Industrial Housing'
    },
    "scholar": {
        value: 'Scholar'
    },
    "elevate": {
        value: 'Elevate'
    },
    "sh_b2c": {
        value: 'SH B2C'
    },
    "zeassetz": {
        value: 'Zeassetz'
    },
    "hr": {
        value: 'HR'
    },
    "corporate": {
        value: 'Corporate'
    },
    "loopByZolo": {
        value: 'Loop By Zolo'
    }

}


// WEBPACK FOOTER //
// ./src/constants/paymentStatus.js